import { FilterKey, ILocationFilterProvider, AreaFilterOptionInformation } from '@studyportals/search-filters';
import { injectable } from 'inversify';
import { FilterOptions } from '../options/FilterOptions';

@injectable()
export class LocationFilterProvider implements ILocationFilterProvider {
	private readonly filterOptions: FilterOptions;

	public constructor(filterOptions: FilterOptions) {
		this.filterOptions = filterOptions;
	}

	public includeContinents = true;

	public identifyAreasFor(countryId: string): string[] {
		const areas = this.filterOptions.getFor(FilterKey.AREA) as AreaFilterOptionInformation[];
		return areas.filter((area) => area.countryIdentity === countryId).map((area) => area.optionValue);
	}

	public identifyTopCountries(): string[] {
		return this.filterOptions.getTopCountryOptions();
	}

	public identifyCountryFor(areaId: string): string {
		const areas = this.filterOptions.getFor(FilterKey.AREA) as AreaFilterOptionInformation[];
		const identifiedArea = areas.find((area) => area.optionValue === areaId);
		if (identifiedArea === undefined) {
			throw new Error(`Area ${areaId} not found`);
		}
		return identifiedArea.countryIdentity;
	}
}
